import styled from 'styled-components';

const TutorialDiv = styled.div`
  position: relative;
`;

export default TutorialDiv;
